// Module
var code = "<nav class=\"SubNav\"> <ul class=\"SubNav__links\"> <li ng-repeat=\"link in ::SubNav.links\"> <a class=\"SubNav__link {{::link.classString }}\" ng-click=\"SubNav.clickLink()\" ui-sref-active=\"SubNav__link--active {{::link.activeClassString }}\" ui-sref=\"{{::link.sref }}\" ui-sref-opts=\"{{::link.srefOpts }}\" data-hook=\"sub-nav-link\"> {{::link.name }} </a> </li> </ul> </nav> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/subNav/subNav.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;